module.exports = __webpack_public_path__ + "assets/img/order.9edac8b6.svg";